/* kahwa-popout-fix.js
   Corrects where the variant / selector dropdown (popout-select) opens.

   Stock Broadcast decides direction from the toggle's position alone:

     toggleListPosition() {
       const t = this.popoutToggle.getBoundingClientRect().top;
       theme.windowHeight / 2 < t && this.popoutList.classList.add('popout-list--top');
     }

   Any toggle sitting below the middle of the window opens upward, even when
   there is ample room below, and the class is only ever added, never removed,
   so the direction never recovers on resize or scroll. On the product page the
   Grind selector sits low in the column, so its list opens upward and covers
   the product description.

   This runs after the theme's own handler and sets the direction from the space
   actually available: open downward unless the list will not fit there and more
   room exists above. Timers rather than requestAnimationFrame, so the pass also
   runs in a backgrounded tab. Falls back to the theme's behaviour on any error. */
(function () {
  var GAP = 8;

  function correct(toggle) {
    try {
      var host = toggle.closest('popout-select, .select-popout, .popout');
      if (!host) return;

      var list = host.querySelector('[data-popout-list]');
      if (!list || !list.classList.contains('popout-list--visible')) return;

      // Measure in the downward state, which is the state we prefer.
      list.classList.remove('popout-list--top');

      var listHeight = list.getBoundingClientRect().height;
      var rect = toggle.getBoundingClientRect();
      var below = window.innerHeight - rect.bottom - GAP;
      var above = rect.top - GAP;

      if (below < listHeight && above > below) {
        list.classList.add('popout-list--top');
      }
    } catch (e) {
      /* leave the theme's own positioning in place */
    }
  }

  function schedule(toggle) {
    setTimeout(function () {
      correct(toggle);
    }, 0);
    // Second pass after the theme's own rAF has set --max-height.
    setTimeout(function () {
      correct(toggle);
    }, 150);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var toggle = target.closest('[data-popout-toggle]');
      if (!toggle) return;

      schedule(toggle);
    },
    true
  );

  window.addEventListener('resize', function () {
    var open = document.querySelectorAll('[data-popout-toggle][aria-expanded="true"]');
    for (var i = 0; i < open.length; i++) correct(open[i]);
  });
})();
